import ClassificationTab from '@/components/permissions/Tabs/ClassificationTab/ClassificationTab.vue';

export default {
	name: 'classificationsPermissionsContent',
	data: () => ({
		name: 'hello',
	}),
	computed: {
		breadcrumbs() {
			return [
				{
					text: 'Inicio',
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: 'Dashboard',
					},
				},
				{
					text: 'Permisos de Aplicación',
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: 'PermissionsHome',
					},
				},
				{
					text: 'Clasificaciones',
					link: true,
					exact: true,
					disabled: true,
					// to: {
					// 	name: 'PermissionHomePage',
					// },
				},
			];
		},
	},
	methods: {},
	components: { ClassificationTab },
};
